//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CustomSelect',
  props: {
    selectList: {
      type: Array,
      default: () => []
    },
    activeValue: {
      type: String,
      default: ''
    },
    labelName: {
      type: String,
      default: ''
    },
    selectedSort: {
      type: Object,
      default: () => ({})
    },
  },
  emits: ['emitOptions'],
  data() {
    return {
      isOpenSelect: false,
    }
  },

  methods: {
    selectHandler() {
      this.isOpenSelect = !this.isOpenSelect;
    },

    changeSort(options) {
      if (!options?.id) {
        return
      }

      this.$emit('emitOptions', options);
      this.selectHandler();
    },

    labelSelectName(name) {
      return name?.[this.labelName] ? name[this.labelName] : '-';
    },
  },

  computed: {
    initSelect() {
      return this.selectedSort?.[this?.labelName] || this.activeValue || this.selectList?.[0]?.[this?.labelName];
    },
  },
}

